import { render, staticRenderFns } from "./BirthdayList.vue?vue&type=template&id=61ab26bc&"
import script from "./BirthdayList.vue?vue&type=script&lang=js&"
export * from "./BirthdayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports